<script lang="ts">
  import { PUBLIC_DO_ASSETS_URL } from '$env/static/public';

  import { CommonDto } from '@do/data-transfer-objects';
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { cn } from '@shared/utils';

  import { ANIMATED_FORMATS, IMAGE_FORMATS, VIDEO_FORMATS } from '../configs';

  export let filename: string | null | undefined;
  export let type: string | null | undefined = undefined;
  export let captionsSrc: string | undefined = undefined;
  export let previewImage: CommonDto.Photo | null = null;
  export let title: string = 'Media content';
  export let isLoaded: boolean = false;
  export let videoControls: boolean = false;
  export let wrapperClasses = '';

  export let imgElement: HTMLImageElement | undefined = undefined;
  export let videoElement: HTMLVideoElement | undefined = undefined;

  const mediaLimitHeightClass = 'max-h-[70vh] aspect-video md:aspect-auto';

  $: src = `${PUBLIC_DO_ASSETS_URL}/${filename}`;
  $: isVideo = type && VIDEO_FORMATS.includes(type.toLowerCase());
  $: isImage = type && IMAGE_FORMATS.includes(type.toLowerCase());
  $: isAnimated = type && ANIMATED_FORMATS.includes(type.toLowerCase());

  function handleLoaded() {
    isLoaded = true;
  }
</script>

{#if !filename}
  <p>No source file available</p>
{:else if isVideo}
  <div class="{cn(mediaLimitHeightClass, wrapperClasses)}">
    <video
      class="h-full w-full"
      loop
      controls="{videoControls}"
      muted
      playsinline
      autoplay
      bind:this="{videoElement}"
      on:loadedmetadata="{handleLoaded}"
      on:loadeddata="{handleLoaded}"
      on:canplaythrough="{handleLoaded}"
    >
      <source {src} {type} />

      {#if captionsSrc}
        <track default kind="captions" src="{captionsSrc}" />
      {/if}
    </video>
  </div>
{:else if isAnimated}
  <div class="{cn(wrapperClasses)}">
    <img bind:this="{imgElement}" {src} alt="{title}" {title} class="w-full" on:load="{handleLoaded}" loading="lazy" />
  </div>
{:else if isImage}
  <div class="{cn(wrapperClasses)}">
    <button on:click>
      <img
        bind:this="{imgElement}"
        {src}
        alt="{title}"
        {title}
        class="w-full"
        on:load="{handleLoaded}"
        loading="lazy"
      />
    </button>
  </div>
{:else if previewImage}
  <DirectusImage
    imageData="{previewImage}"
    imgClasses="w-full"
    alt="{title}"
    pictureSizes="{{
      default: '100vw',
      'min-1024': '60vw',
      'min-1280': '67vw',
    }}"
    presetKeys="{Preset.Thumbnail}"
    bind:imgElement
    loading="lazy"
    onErrorPlaceholderStatic="{{
      src: '/images/artwork-placeholder.png',
      width: 1000,
      height: 1000,
    }}"
  />
{/if}
